import { pushDataLayerEvent } from '../CommonJs/dataLayer.js';

document.querySelector('footer').addEventListener('click', function (event) {
    const link = event.target.closest('a');

    pushDataLayerEvent({
        event: 'select_footer_link',
        click_name: link.textContent.trim()
    });
});